// Module
var code = `<div class="rb-element rb-break rb-live clearfix"></div>`;
// Exports
export default code;